import React from "react";
import "./Media.css";

const Media = () => {
  return (
    <div className="media_parent_div">
      <h1>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquam et
        magni odit expedita consequuntur ab vel, ea pariatur sint quisquam
        aspernatur dolorum sapiente, nostrum esse impedit, quis explicabo
        cupiditate quae?
      </h1>
    </div>
  );
};

export default Media;
